import { render, staticRenderFns } from "./FileIcon.vue?vue&type=template&id=48b58f22&scoped=true&"
import script from "./FileIcon.vue?vue&type=script&lang=ts&"
export * from "./FileIcon.vue?vue&type=script&lang=ts&"
import style0 from "./FileIcon.vue?vue&type=style&index=0&id=48b58f22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b58f22",
  null
  
)

export default component.exports